import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'baas-icon-text',
    templateUrl: './baas-icon-text.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTooltip],
    host: { class: 'lv-icon-text' }
})
export class BaasIconText {
    /** Font Awesome class(es) for the icon, e.g. 'fa-calendar' */
    readonly iconClass = input.required<string>();
    /** Optional bold label shown between icon and text */
    readonly label = input<string>();
    /** Value text */
    readonly text = input.required<string>();
    /** Optional tooltip shown on hover */
    readonly tooltip = input<string>();
}
